import { render, staticRenderFns } from "./Customer_service_triage.vue?vue&type=template&id=7ae38a1c&scoped=true&"
import script from "./Customer_service_triage.vue?vue&type=script&lang=js&"
export * from "./Customer_service_triage.vue?vue&type=script&lang=js&"
import style0 from "./Customer_service_triage.vue?vue&type=style&index=0&id=7ae38a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae38a1c",
  null
  
)

export default component.exports